<bb-empty-state-ui
  image="ic_scenario_coin_empty"
  title="No transactions found"
  subtitle="Please change your filters<br>and try again"
></bb-empty-state-ui>
